module.exports = __webpack_public_path__ + "img/com.electrolux.oeno.fcf3ec33.webp";